import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { display } from 'styled-system';

import { getAppUIVariantConfig } from 'Util/uiVariantSet';

import { Flex, Fixed, SvgIcon } from '../Base';

import UserMenu from './UserMenu';

const Container = styled(Flex)`
  height: ${(props) => props.height};
  align-items: center;
`;

const ResponsiveBox = styled(Flex)`
  position: relative;

  align-items: center;
  height: 100%;
  ${display}
`;

const renderHamburgerStyle = (style) => {
  switch (style) {
    case 'Branding': {
      return 'primary';
    }
    case 'Dark': {
      return 'text';
    }
    case 'Light':
    default: {
      return 'white';
    }
  }
};

class UserButton extends Component {
  state = {
    isMenuOpen: false,
    hamburgerMenuStyle: getAppUIVariantConfig().HamburgerMenu,
  };

  handleClickButton = () => {
    this.setState({
      isMenuOpen: this.state.isMenuOpen === true ? false : true,
    });
  };

  handleCloseMenu = () => {
    this.setState({
      isMenuOpen: false,
    });
  };

  handleMenuItemClick = (e, index, item) => {
    if (item.closeMenuOnClick) {
      this.setState({
        isMenuOpen: false,
      });
    }
    this.props.onMenuItemClick(e, index, item);
  };

  handleUserInfoClick = (e) => {
    if (this.props.closeMenuOnClickUserInfo) {
      this.setState({
        isMenuOpen: false,
      });
    }
    this.props.onClickUserInfo(e);
  };

  render() {
    const {
      name,
      providerName,
      image,
      isLogin,
      menuItems,
      height,
      menuContainer,
      onClickLogIn,
      onClickRegister,
      translation,
      logInError,
      onOpenLoginModal,
      onCloseLoginModal,

      displayName,
    } = this.props;
    const { isMenuOpen, hamburgerMenuStyle } = this.state;
    const dataTestIdPrefix = 'btn-mycourse';
    return (
      <Container height={height}>
        <ResponsiveBox display={'flex'} pr={3}>
          <SvgIcon
            icon={SvgIcon.ICON_LIST.MENU_BURGER}
            size={24}
            color={renderHamburgerStyle(hamburgerMenuStyle)}
            style={{ zIndex: 1, cursor: 'pointer' }}
            onClick={this.handleClickButton}
            data-testid={`${dataTestIdPrefix}-hamburger-menu`}
          />
          <UserMenu
            display={'flex'}
            open={isMenuOpen}
            menuItems={menuItems}
            onMenuItemClick={this.handleMenuItemClick}
            onClickUserInfo={this.handleUserInfoClick}
            container={menuContainer}
            onClickLogIn={onClickLogIn}
            onClickRegister={onClickRegister}
            isLogin={isLogin}
            translation={translation}
            image={image}
            name={name}
            displayName={displayName}
            providerName={providerName}
            logInError={logInError}
            onOpenLoginModal={onOpenLoginModal}
            onCloseLoginModal={onCloseLoginModal}
            onClose={this.handleCloseMenu}
          />
          {isMenuOpen && (
            <Fixed
              top={0}
              right={0}
              bottom={0}
              left={0}
              onClick={this.handleCloseMenu}
              bg={'transparent'}
            />
          )}
        </ResponsiveBox>
      </Container>
    );
  }
}

UserButton.propTypes = {
  isLogin: PropTypes.bool,
  height: PropTypes.string,
  name: PropTypes.string,
  providerName: PropTypes.string,
  image: PropTypes.string,
  menuItems: PropTypes.array,
  onMenuItemClick: PropTypes.func,
  onClickUserInfo: PropTypes.func,
  closeMenuOnClickUserInfo: PropTypes.bool,
  menuContainer: PropTypes.object,
  onClickLogIn: PropTypes.func,
  onClickRegister: PropTypes.func,
  onOpenLoginModal: PropTypes.func,
  onCloseLoginModal: PropTypes.func,
  dropdownIcon: PropTypes.object,
  hamburgerIcon: PropTypes.object,
  closeIcon: PropTypes.object,
  checkboxIcon: PropTypes.object,
  translation: PropTypes.shape({
    button: PropTypes.shape({
      logIn: PropTypes.string,
      register: PropTypes.string,
    }),
    logInModal: PropTypes.shape({
      headline: PropTypes.shape({
        firstLine: PropTypes.string,
        secondLine: PropTypes.string,
      }),
      form: PropTypes.shape({
        username: PropTypes.shape({
          label: PropTypes.string,
          placeholder: PropTypes.string,
          error: PropTypes.string,
        }),
        password: PropTypes.shape({
          label: PropTypes.string,
          placeholder: PropTypes.string,
          error: PropTypes.string,
        }),
        rememberData: PropTypes.shape({
          label: PropTypes.string,
        }),
        submit: PropTypes.shape({
          label: PropTypes.string,
        }),
      }),
      footer: PropTypes.shape({
        firstText: PropTypes.string,
        secondText: PropTypes.string,
        register: PropTypes.string,
      }),
    }),
  }),
};

UserButton.defaultProps = {
  menuItems: [],
  onMenuItemClick: () => {},
  onClickUserInfo: () => {},
  onClickLogIn: () => {},
  onClickRegister: () => {},
  onOpenLoginModal: () => {},
  onCloseLoginModal: () => {},
  closeMenuOnClickUserInfo: true,
  dropdownIcon: { iconName: 'licn-dropdown', size: '21px' },
  hamburgerIcon: { iconName: 'licn-hamburger', size: '21px' },
  closeIcon: { iconName: 'licn-close', size: '21px' },
  checkboxIcon: { iconName: 'licn-check', size: '21px' },
  translation: {
    button: {
      logIn: 'ล็อกอิน',
      register: 'ลงทะเบียน',
    },
    logInModal: {
      headline: {
        firstLine: 'ยินดีต้อนรับ!',
        secondLine: 'สู่เรียนออนไลน์กับไลน์',
      },
      form: {
        username: {
          label: 'ชื่อผู้ใช้่',
          placeholder: 'กรุณากรอกชื่อผู้ใช้ ...',
          error: '*กรุณาใส่ชื่อผู้ใช้',
        },
        password: {
          label: 'รหัสผ่าน',
          placeholder: 'กรุณากรอกรหัสผ่าน ...',
          error: '*กรุณาใส่รหัสผ่านให้ถูกต้อง',
        },
        rememberData: {
          label: 'จำข้อมูลประจำตัวของผู้ใช้',
        },
        submit: {
          label: 'เข้าสู่ระบบ',
        },
      },
      footer: {
        firstText: 'หากยังไม่เป็นสมาชิก',
        secondText: 'ฟรี!',
        register: 'กรุณาลงทะเบียน',
      },
    },
  },
};

export default UserButton;
